"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Facebook = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Facebook = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M17.667 4h-4c-.737 0-1.334.597-1.334 1.333v4h5.334a.467.467 0 01.453.614l-.987 2.933a.667.667 0 01-.626.453h-4.174v10a.667.667 0 01-.666.667H8.333a.667.667 0 01-.666-.667v-10h-2A.667.667 0 015 12.667V10c0-.368.298-.667.667-.667h2v-4A5.333 5.333 0 0113 0h4.667c.368 0 .666.298.666.667v2.666a.667.667 0 01-.666.667z" })); };
exports.Facebook = Facebook;
//# sourceMappingURL=facebook.js.map